module.exports = __webpack_public_path__ + "img/snapchat.014940b0.svg";